import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import {ColDef} from "ag-grid-community";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";
import AGGridAttachmentTemplateCellRenderer from "@/components/inputs/AGGridAttachmentTemplateCellRenderer.vue";

export default class AGGridAttachmentColumn extends AGGridColumn {
  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = AGGridAttachmentTemplateCellRenderer
    colDef.editable = false;
    colDef.cellRendererParams = {
      entityType: this.entityType,
    }
    return colDef;
  }
}
